// generated from 9_404 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasMarkedAsSpamFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_marked_as_spam_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 2_107 (22.41%), defined 7_297 (77.59%)
  // true 951 (13.03%), false 6_346 (86.97%)
  raw_value: z.boolean().optional(),
  // true 1_148 (12.21%), false 8_256 (87.79%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
